import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { acquisitionChannelKeys } from '@/lib/queryKeys';
import { acquisitionChannelEndpoints } from '@/lib/api/endpoints';
import { apiPatch, operationsClient } from '@/lib/api';
import type { AcquisitionChannel, UpdateAcquisitionChannelDto } from '@/types/acquisitionChannel';

export function useUpdateAcquisitionChannel() {
  const queryClient = useQueryClient();

  return useApiMutation<AcquisitionChannel, { id: string; dto: UpdateAcquisitionChannelDto }>({
    mutationFn: ({ id, dto }) =>
      apiPatch<AcquisitionChannel, UpdateAcquisitionChannelDto>(
        operationsClient,
        acquisitionChannelEndpoints.detail(id),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: acquisitionChannelKeys.all(),
      });
      toast.success('Channel updated');
    },
  });
}
